<template>
    <table class="w-100">
    <tr>
      <td class="w-25"><label>{{ $t('accountAdditionalDetails.details.document_type') }}</label></td>
      <td>{{ details.type }}</td>
    </tr>
    <tr>
      <td class="w-25"><label>{{ $t('accountAdditionalDetails.details.document_identifier') }}</label></td>
      <td>{{ details.document_identifier }}</td>
    </tr>
    </table>
</template>
<script>
export default {
  name: 'AccountAdditionalDetailsDataViewDocument',
  components: {},
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  computed: {}
};
</script>
<style></style>
